/* ============
 * Company Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from './transformer';
import AccountTransformer from './common/address';

export default class CompanyTransformer extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param account The fetched account
   *
   * @returns {Object} The transformed account
   */
  static fetch(response) {
    return {
      id: response.id,
      activatedNewForm: response.activated_new_form,
      name: response.name,
      kpi: response.kpi,
      tags: response.tags,
      filterTags: response.filter_tags,
      hourly_rate: response.hourly_rate,
      description: response.description,
      reportingUrl: response.data_studio_reporting_url,
      logo: response.logo,
      companySize: response.company_size,
      businessSector: response.business_sector,
      accountant: response.accountant,
      accountantEmailList: response.accountant_email_list,
      billingAddress: AccountTransformer.fetch(response.billing_address),
      last_order_address: response.last_order_address,
      hourly_rate_evolution: response.hourly_rate_evolution,
      do_not_apply_last_minute_order_fees: response.do_not_apply_last_minute_order_fees,
      do_not_apply_vat: response.do_not_apply_vat,
      do_not_increase_hours_by_night: response.do_not_increase_hours_by_night,
      show_invoice_details: response.show_invoice_details,
      is_staffing_auto_enable: response.is_staffing_auto_enable,
      created: response.created,
      paymentMethod: response.payment_method,
      iban: response.iban,
      countPendingQuote: parseInt(response.count_pending_quote, 10),
      children: response.children,
      billingStatus: response.billing_status,
      paymentStatus: response.customer_payment_status,
      orderBlocked: response.customer_order_blocked,
      hasValidPaymentMethod: response.has_valid_payment_method,
      isMandateInherited: response.is_mandate_inherited,
      mandate: response.mandate,
      hasGsaDerogation: response.has_gsa_derogation,
      businessSectorCode: response.business_sector_code,
      siret: response.siret,
      isTempAgencyMode: response.is_temp_agency_mode,
      tempAgencySwitchDate: response.temp_agency_switch_date,
    };
  }
}
